/* =====================================================
   Good Deeds Tracker — good-deeds.js
   assets/good-deeds.js
   ===================================================== */

window.GD = {};

(function () {
  'use strict';

  /* ── Islamic months ── */
  var HIJRI_MONTHS = [
    'Muharram','Safar',"Rabi' al-Awwal","Rabi' al-Thani",
    'Jumada al-Awwal','Jumada al-Thani','Rajab',"Sha'ban",
    'Ramadan','Shawwal',"Dhul Qa'dah",'Dhul Hijjah'
  ];

  function currentHijriYear() {
    var msPerHijriYear = 354.37 * 24 * 60 * 60 * 1000;
    var hijriEpoch     = new Date('0622-07-16').getTime();
    return Math.floor((Date.now() - hijriEpoch) / msPerHijriYear) + 1;
  }

  function fillYearSelect(selectId) {
    var el = document.getElementById(selectId);
    if (!el) return;
    var cur = currentHijriYear();
    el.innerHTML = '';
    for (var y = cur - 2; y <= cur + 3; y++) {
      var opt = document.createElement('option');
      opt.value       = y;
      opt.textContent = y + ' AH';
      if (y === cur) opt.selected = true;
      el.appendChild(opt);
    }
  }

  function hijriMonthName(num) { return HIJRI_MONTHS[(num || 1) - 1] || 'Muharram'; }

  /* ── Category emoji ── */
  var CATEGORY_EMOJI = {
    'Kindness':'🤲','Prayer':'🕌','Helping at home':'🏠',
    'Charity':'💝','Learning':'📚','Being kind':'😊'
  };

  /* ── Badges ── */
  var BADGES = [
    { id:'first',   icon:'🌟', name:'First deed',  desc:'Logged first deed',  check:function(d)    { return d.length>=1; } },
    { id:'kind5',   icon:'❤️', name:'Kind heart',  desc:'5 kindness deeds',   check:function(d)    { return d.filter(function(x){return x.cat==='Kindness';}).length>=5; } },
    { id:'prayer3', icon:'🌙', name:'Prayer star', desc:'3 prayer deeds',     check:function(d)    { return d.filter(function(x){return x.cat==='Prayer';}).length>=3; } },
    { id:'helper5', icon:'🏠', name:'Home helper', desc:'5 home help deeds',  check:function(d)    { return d.filter(function(x){return x.cat==='Helping at home';}).length>=5; } },
    { id:'streak5', icon:'🔥', name:'On fire',     desc:'5-day streak',       check:function(d,s)  { return s>=5; } },
    { id:'champ30', icon:'🏆', name:'Champion',    desc:'30 deeds total',     check:function(d)    { return d.length>=30; } }
  ];

  function getLevel(n) {
    if (n>=50) return '🌟 Champion';
    if (n>=30) return '✨ Nujoom';
    if (n>=15) return '💫 Noor';
    if (n>=5)  return '🌱 Seedling';
    return '🌙 Beginner';
  }

  /* ── Storage ── */
  function storageKey() { return 'gd_data_'+(window.GD_CUSTOMER_ID||'guest'); }
  function loadData() {
    try { var r=localStorage.getItem(storageKey()); if(r) return JSON.parse(r); } catch(e){}
    return {children:[]};
  }
  function saveData(d) {
    try { localStorage.setItem(storageKey(), JSON.stringify(d)); }
    catch(e) { console.warn('GD save error',e); }
  }

  /* ── Helpers ── */
  function calcStreak(deeds) {
    if (!deeds||!deeds.length) return 0;
    var dates=deeds.map(function(d){return d.date.split('T')[0];});
    var unique=dates.filter(function(v,i,a){return a.indexOf(v)===i;}).sort().reverse();
    var streak=0, today=new Date();
    for (var i=0;i<unique.length;i++) {
      var exp=new Date(today); exp.setDate(today.getDate()-i);
      if (unique[i]===exp.toISOString().split('T')[0]) {streak++;} else {break;}
    }
    return streak;
  }
  function countThisWeek(deeds) {
    var cutoff=new Date(Date.now()-7*24*60*60*1000);
    return (deeds||[]).filter(function(d){return new Date(d.date)>=cutoff;}).length;
  }
  function showToast(msg) {
    var t=document.getElementById('gd-toast'); if(!t) return;
    t.textContent=msg; t.classList.add('show');
    setTimeout(function(){t.classList.remove('show');},2800);
  }
  function formatDate(iso) {
    var diff=Math.floor((Date.now()-new Date(iso))/86400000);
    if(diff===0) return 'Today'; if(diff===1) return 'Yesterday';
    return diff+' days ago';
  }
  function esc(s) {
    return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }

  /* ── Compress image to base64 (max 200px wide, JPEG 0.75) ── */
  function compressImage(file, callback) {
    var reader = new FileReader();
    reader.onload = function(e) {
      var img = new Image();
      img.onload = function() {
        var MAX = 200;
        var w = img.width, h = img.height;
        if (w > MAX) { h = Math.round(h * MAX / w); w = MAX; }
        var canvas = document.createElement('canvas');
        canvas.width = w; canvas.height = h;
        var ctx = canvas.getContext('2d');
        /* Draw circular clip */
        ctx.beginPath();
        ctx.arc(w/2, h/2, Math.min(w,h)/2, 0, Math.PI*2);
        ctx.closePath();
        ctx.clip();
        ctx.drawImage(img, 0, 0, w, h);
        callback(canvas.toDataURL('image/jpeg', 0.75));
      };
      img.src = e.target.result;
    };
    reader.readAsDataURL(file);
  }

  /* ── Render avatar in a container (photo takes priority over emoji) ── */
  function renderAvatarInBanner(photo, emoji) {
    var emojiEl = document.getElementById('tracker-avatar-emoji');
    var photoEl = document.getElementById('tracker-avatar-photo');
    if (!emojiEl || !photoEl) return;
    if (photo) {
      photoEl.src = photo;
      photoEl.style.display = 'block';
      emojiEl.style.display  = 'none';
    } else {
      emojiEl.textContent    = emoji || '🌸';
      emojiEl.style.display  = 'block';
      photoEl.style.display  = 'none';
    }
  }

  /* ── Render a child card avatar (photo or emoji) ── */
  function childAvatarHTML(child) {
    if (child.photo) {
      return '<div class="gd-child-avatar gd-child-avatar--photo">' +
               '<img src="' + esc(child.photo) + '" alt="' + esc(child.name) + '" />' +
             '</div>';
    }
    return '<div class="gd-child-avatar">' + (child.avatar||'🌸') + '</div>';
  }

  /* ── Family bar avatar ── */
  function familyAvatarHTML(child) {
    if (child.photo) {
      return '<div class="gd-family-avatar gd-family-avatar--photo">' +
               '<img src="' + esc(child.photo) + '" alt="" />' +
             '</div>';
    }
    return '<div class="gd-family-avatar">' + (child.avatar||'🌸') + '</div>';
  }

  /* ── State ── */
  var currentChildIndex  = -1;
  var selectedAvatarAdd  = '🌸';
  var selectedAvatarEdit = '🌸';
  var pendingPhotoAdd    = null;   /* base64 string or null */
  var pendingPhotoEdit   = null;
  var selectedDeedCat    = 'Kindness';

  /* ══════════════════════════════════════
     GD PUBLIC API
  ══════════════════════════════════════ */
  window.GD = {

    showView: function(name) {
      document.querySelectorAll('.gd-view').forEach(function(v){v.style.display='none';});
      var target=document.getElementById('view-'+name);
      if (target) { target.style.display='block'; target.scrollIntoView({behavior:'smooth',block:'start'}); }
      else { console.warn('GD: view not found → view-'+name); }
      if (name==='dashboard') GD.renderDashboard();
      if (name==='add-child') {
        fillYearSelect('input-child-year');
        pendingPhotoAdd = null;
        GD._resetPhotoUI('add');
      }
    },

    /* ── Photo handler (called by file input onchange) ── */
    handlePhoto: function(input, context) {
      var file = input.files && input.files[0];
      if (!file) return;
      compressImage(file, function(base64) {
        if (context === 'add') {
          pendingPhotoAdd = base64;
          GD._setPhotoUI('add', base64);
          /* Clear emoji selection since photo takes over */
          document.querySelectorAll('#avatar-picker-add .gd-av-opt').forEach(function(a){a.classList.remove('active');});
        } else {
          pendingPhotoEdit = base64;
          GD._setPhotoUI('edit', base64);
          document.querySelectorAll('#avatar-picker-edit .gd-av-opt').forEach(function(a){a.classList.remove('active');});
        }
      });
    },

    removePhoto: function(context) {
      if (context === 'add') { pendingPhotoAdd = null; GD._resetPhotoUI('add'); }
      else                   { pendingPhotoEdit = null; GD._resetPhotoUI('edit'); }
    },

    _setPhotoUI: function(context, base64) {
      var img         = document.getElementById(context+'-photo-img');
      var placeholder = document.getElementById(context+'-photo-placeholder');
      var removeBtn   = document.getElementById(context+'-photo-remove');
      if (img)         { img.src = base64; img.style.display = 'block'; }
      if (placeholder)   placeholder.style.display = 'none';
      if (removeBtn)     removeBtn.style.display   = 'inline-block';
    },

    _resetPhotoUI: function(context) {
      var img         = document.getElementById(context+'-photo-img');
      var placeholder = document.getElementById(context+'-photo-placeholder');
      var removeBtn   = document.getElementById(context+'-photo-remove');
      var fileInput   = document.getElementById(context+'-photo-input');
      if (img)         { img.src = ''; img.style.display = 'none'; }
      if (placeholder)   placeholder.style.display = 'block';
      if (removeBtn)     removeBtn.style.display   = 'none';
      if (fileInput)     fileInput.value           = '';
    },

    /* ── Avatar (emoji) picker ── */
    pickAvatar: function(el, context) {
      var pickerId = context==='edit' ? 'avatar-picker-edit' : 'avatar-picker-add';
      var picker   = document.getElementById(pickerId);
      if (picker) picker.querySelectorAll('.gd-av-opt').forEach(function(a){a.classList.remove('active');});
      el.classList.add('active');
      var emoji = el.getAttribute('data-emoji')||el.textContent.trim();
      if (context==='edit') { selectedAvatarEdit=emoji; pendingPhotoEdit=null; GD._resetPhotoUI('edit'); }
      else                  { selectedAvatarAdd=emoji;  pendingPhotoAdd=null;  GD._resetPhotoUI('add'); }
    },

    /* ── Dashboard ── */
    renderDashboard: function() {
      var grid=document.getElementById('child-grid'); if(!grid) return;
      var data=loadData();
      var html='';
      data.children.forEach(function(child,idx) {
        var streak=calcStreak(child.deeds);
        var total=(child.deeds||[]).length;
        var mName=hijriMonthName(child.month);
        html+=
          '<div class="gd-child-card" onclick="GD.openChild('+idx+')">' +
            childAvatarHTML(child) +
            '<p class="gd-child-name">'+esc(child.name)+'</p>' +
            '<p class="gd-child-deeds">⭐ '+total+' deed'+(total!==1?'s':'')+'</p>' +
            '<p class="gd-child-streak">🔥 '+streak+'-day streak</p>' +
            '<p class="gd-child-month">🌙 '+esc(mName)+' '+(child.year||currentHijriYear())+' AH</p>' +
          '</div>';
      });
      html+=
        '<div class="gd-add-card" onclick="GD.showView(\'add-child\')">' +
          '<span class="gd-add-icon">➕</span>' +
          '<span class="gd-add-label">Add a child</span>' +
        '</div>';
      grid.innerHTML=html;

      var summaryBox=document.getElementById('summary-box');
      var barsEl=document.getElementById('family-bars');
      if (summaryBox&&barsEl) {
        if (data.children.length>1) {
          summaryBox.style.display='block';
          var maxD=Math.max.apply(null,data.children.map(function(c){return (c.deeds||[]).length||0;}))||1;
          barsEl.innerHTML=data.children.map(function(child){
            var total=(child.deeds||[]).length;
            var pct=Math.round((total/maxD)*100);
            return '<div class="gd-family-bar-item">' +
              familyAvatarHTML(child) +
              '<div style="flex:1;"><p class="gd-family-name">'+esc(child.name)+'</p>' +
              '<div class="gd-family-track"><div class="gd-family-fill" style="width:'+pct+'%"></div></div></div>' +
              '<span class="gd-family-count">⭐ '+total+'</span>' +
            '</div>';
          }).join('');
        } else { summaryBox.style.display='none'; }
      }
    },

    /* ── Open tracker ── */
    openChild: function(idx) {
      var data=loadData(); var child=data.children[idx]; if(!child) return;
      currentChildIndex=idx;
      var deeds=child.deeds||[];
      var streak=calcStreak(deeds), total=deeds.length, week=countThisWeek(deeds);
      var goal=child.goal||30, mName=hijriMonthName(child.month), year=child.year||currentHijriYear();

      renderAvatarInBanner(child.photo, child.avatar);
      document.getElementById('tracker-name').textContent   = child.name+'\u2019s good deeds';
      document.getElementById('tracker-sub').textContent    = mName+' '+year+' AH · Keep going!';
      document.getElementById('tracker-level').textContent  = getLevel(total);
      document.getElementById('stat-total').textContent     = total;
      document.getElementById('stat-week').textContent      = week;
      document.getElementById('stat-streak').textContent    = streak;
      document.getElementById('prog-goal-label').textContent  = goal;
      document.getElementById('prog-month-label').textContent = mName;
      document.getElementById('prog-count').textContent     = total+' / '+goal;
      var pct=Math.min(Math.round((total/goal)*100),100);
      document.getElementById('prog-fill').style.width=pct+'%';
      var left=Math.max(goal-total,0);
      document.getElementById('prog-note').textContent=left>0
        ?'Almost there! Just '+left+' more deed'+(left!==1?'s':'')+' to go 💪'
        :'Goal complete! MashaAllah! 🎉';

      GD.renderDeedList(deeds);
      GD.renderBadges(deeds,streak);
      GD.showView('tracker');
    },

    renderDeedList: function(deeds) {
      var el=document.getElementById('deed-list'); if(!el) return;
      if (!deeds||!deeds.length) {
        el.innerHTML='<p class="gd-empty-msg">No deeds yet — add the first one below! 👇</p>'; return;
      }
      el.innerHTML=deeds.slice().reverse().slice(0,10).map(function(d){
        var emoji=CATEGORY_EMOJI[d.cat]||'🌟';
        return '<div class="gd-deed-item">' +
          '<div class="gd-deed-bubble">'+emoji+'</div>' +
          '<div style="flex:1;"><p class="gd-deed-title">'+esc(d.desc||d.cat)+'</p>' +
          '<p class="gd-deed-who">'+formatDate(d.date)+' · '+esc(d.cat)+'</p></div>' +
          '<span class="gd-deed-pts">⭐ 1</span></div>';
      }).join('');
    },

    renderBadges: function(deeds, streak) {
      var el=document.getElementById('badges-grid'); if(!el) return;
      el.innerHTML=BADGES.map(function(b){
        var earned=b.check(deeds,streak);
        return '<div class="gd-badge-card'+(earned?'':' locked')+'">' +
          '<span class="gd-badge-icon">'+b.icon+'</span>' +
          '<p class="gd-badge-name">'+b.name+'</p>' +
          '<p class="gd-badge-desc">'+b.desc+(earned?' ✓':' — locked')+'</p></div>';
      }).join('');
    },

    pickDeed: function(el) {
      document.querySelectorAll('.gd-deed-opt').forEach(function(o){o.classList.remove('active');});
      el.classList.add('active');
      selectedDeedCat=el.getAttribute('data-cat')||'Kindness';
    },

    /* ── Save new child ── */
    saveChild: function() {
      var name =(document.getElementById('input-child-name')||{}).value||'';
      var age  =parseInt((document.getElementById('input-child-age')||{}).value)||0;
      var goal =parseInt((document.getElementById('input-child-goal')||{}).value)||30;
      var month=parseInt((document.getElementById('input-child-month')||{}).value)||1;
      var year =parseInt((document.getElementById('input-child-year')||{}).value)||currentHijriYear();
      name=name.trim();
      if (!name){showToast('Please enter a name! 😊');return;}

      /* Use photo if uploaded, else use selected emoji */
      var photo  = pendingPhotoAdd||null;
      var avatar = photo ? '🌸' : (selectedAvatarAdd||'🌸');

      var data=loadData();
      data.children.push({name:name,age:age,avatar:avatar,photo:photo,goal:goal,month:month,year:year,deeds:[]});
      saveData(data);

      ['input-child-name','input-child-age','input-child-goal'].forEach(function(id){
        var el=document.getElementById(id); if(el) el.value='';
      });
      selectedAvatarAdd='🌸'; pendingPhotoAdd=null;
      var picker=document.getElementById('avatar-picker-add');
      if(picker){
        picker.querySelectorAll('.gd-av-opt').forEach(function(a){a.classList.remove('active');});
        var first=picker.querySelector('.gd-av-opt'); if(first) first.classList.add('active');
      }
      GD._resetPhotoUI('add');
      showToast(name+' has been added! 🌟');
      GD.showView('dashboard');
    },

    /* ── Open edit form pre-filled ── */
    openEditChild: function() {
      if (currentChildIndex<0) return;
      var data=loadData(); var child=data.children[currentChildIndex]; if(!child) return;
      fillYearSelect('edit-child-year');

      document.getElementById('edit-child-name').value  = child.name;
      document.getElementById('edit-child-age').value   = child.age||'';
      document.getElementById('edit-child-goal').value  = child.goal||30;
      document.getElementById('edit-child-month').value = child.month||1;
      document.getElementById('edit-child-year').value  = child.year||currentHijriYear();

      /* Show existing photo if any */
      pendingPhotoEdit = child.photo || null;
      if (child.photo) {
        GD._setPhotoUI('edit', child.photo);
      } else {
        GD._resetPhotoUI('edit');
      }

      selectedAvatarEdit=child.avatar||'🌸';
      var picker=document.getElementById('avatar-picker-edit');
      if(picker){
        picker.querySelectorAll('.gd-av-opt').forEach(function(a){
          a.classList.toggle('active', a.getAttribute('data-emoji')===selectedAvatarEdit);
        });
      }
      GD.showView('edit-child');
    },

    cancelEdit: function() {
      if(currentChildIndex>=0){GD.openChild(currentChildIndex);}else{GD.showView('dashboard');}
    },

    /* ── Save edited child ── */
    updateChild: function() {
      if (currentChildIndex<0) return;
      var name =(document.getElementById('edit-child-name')||{}).value||'';
      var age  =parseInt((document.getElementById('edit-child-age')||{}).value)||0;
      var goal =parseInt((document.getElementById('edit-child-goal')||{}).value)||30;
      var month=parseInt((document.getElementById('edit-child-month')||{}).value)||1;
      var year =parseInt((document.getElementById('edit-child-year')||{}).value)||currentHijriYear();
      name=name.trim();
      if(!name){showToast('Please enter a name! 😊');return;}

      var photo  = pendingPhotoEdit||null;
      var avatar = photo ? (data.children[currentChildIndex]&&data.children[currentChildIndex].avatar||'🌸') : selectedAvatarEdit;

      var data=loadData(); var child=data.children[currentChildIndex]; if(!child) return;
      child.name=name; child.age=age; child.avatar=avatar;
      child.photo=photo; child.goal=goal; child.month=month; child.year=year;
      saveData(data);

      showToast('Profile updated! ✏️');
      GD.openChild(currentChildIndex);
    },

    /* ── Log deed ── */
    logDeed: function() {
      if(currentChildIndex<0) return;
      var descEl=document.getElementById('deed-description');
      var desc=(descEl?descEl.value:'').trim();
      var data=loadData(); var child=data.children[currentChildIndex]; if(!child) return;
      child.deeds=child.deeds||[];
      child.deeds.push({cat:selectedDeedCat,desc:desc||selectedDeedCat,date:new Date().toISOString()});
      saveData(data);
      if(descEl) descEl.value='';
      showToast('Deed added! MashaAllah! 🎉');
      GD.openChild(currentChildIndex);
    },

    /* ── Delete child ── */
    confirmDeleteChild: function() {
      if(currentChildIndex<0) return;
      var data=loadData(); var child=data.children[currentChildIndex]; if(!child) return;
      if(!confirm('Remove '+child.name+"'s profile? This cannot be undone.")) return;
      data.children.splice(currentChildIndex,1);
      saveData(data);
      currentChildIndex=-1;
      showToast('Profile removed.');
      GD.showView('dashboard');
    }
  };

  /* ── Init ── */
  function init() {
    var app=document.getElementById('gd-app'); if(!app) return;
    GD.renderDashboard();
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}else{init();}

})();
